import type { TSiteSectionsTreeData } from "@/app/tools/new-section-management/site-sections-tree/site-sections-tree.types";
import type { ISelectSectionSimpleTreeExpose } from "@voltalis/ui-kit/components";
import type { Ref } from "vue";

import { nextTick } from "vue";

import { isPendingSiteSectionPreviewNode } from "@/app/tools/new-section-management/site-sections-tree/site-sections-tree-pending-preview";

export async function scrollSiteSectionPreviewIntoView(
  treeRef: Readonly<Ref<ISelectSectionSimpleTreeExpose<TSiteSectionsTreeData> | null | undefined>>,
): Promise<void> {
  await nextTick();
  const tree = treeRef.value;
  if (!tree) return;

  await tree.forceUpdate();
  tree.scrollToNode(isPendingSiteSectionPreviewNode);
}
